import get from 'lodash.get';

export default function ecommerceFactory(services) {
  const thisService = {
    getProducts,
  };
  return thisService;

  //////////////////

  function getProducts() {
    return services.http.get('ecommerce', 'organizations/products', { cache: true }).then(resp => {
      return resp.data;
    });
  }
}
